import { NotificationModel } from "@custom-types/NotificationModel";

export const countUnreadNotification = (notifications: Array<NotificationModel>): number => {
    const newNotifications = notifications.filter((n: NotificationModel) => !n.isRead);
    return newNotifications.length;
};
